import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _Promise from 'babel-runtime/core-js/promise';
import _typeof from 'babel-runtime/helpers/typeof';
import _Array$from from 'babel-runtime/core-js/array/from';
import _extends from 'babel-runtime/helpers/extends';
import _Object$assign from 'babel-runtime/core-js/object/assign';
import UIManager from '@xunlei/thunder-ui-vue/lib/mixins/drag-mixin/ui-manage.js';
import { warn, throttle } from '@xunlei/thunder-ui-vue/lib/utils/util.js';

function createDragMixin(options) {
  if (process.env.NODE_ENV !== 'production') {
    if (!options.container) {
      warn('DragMixin', 'container option is required');
    }
    if (!options.getList) {
      warn('DragMixin', 'getList option is required');
    }
    if (options.multiple && !options.getMoveIndexs) {
      warn('DragMixin', 'getMoveIndexs option is required with multiple mode');
    }
    if (!options.onUpdateList) {
      warn('DragMixin', 'onUpdateList option is required');
    }
  }
  options = _Object$assign({}, {
    supportScroll: false,
    vertical: false,
    multiple: false
  }, options);

  return {
    props: {
      sortable: Boolean,
      offset: {
        /* minimum distance to start scrolling */
        type: Number,
        default: 10
      },
      scrollSpeed: {
        type: Number,
        default: 2
      },
      distance: {
        type: Number,
        default: 8 // 移动距离超过这个数值才认为是拖拽，防止手抖
      },
      sortByHandler: {
        type: Boolean,
        default: false
      },
      handleClassList: {
        type: Array
      }

    },
    data: function data() {
      return {
        sorting: false,
        moving: false,
        moveTargetIndexs: null
      };
    },
    created: function created() {
      this.ui = new UIManager(_extends({}, options, {
        vm: this
      }));
      this.onSortingThrottled = throttle(this.onSorting, 16);
    },
    mounted: function mounted() {
      var _this = this;

      if (process.env.NODE_ENV !== 'production') {
        if (options.sortByHandler && !options.handleClassList.length) {
          warn('The length of handleClassList should bigger than one when sortByHandler is true.');
        }
      }
      if (this.sortable) {
        options.container.call(this).addEventListener('scroll', this.handleScroll);
        this.$watch(options.getList, function () {
          _this.traceEvent();
        }, {
          immediate: true
        });
      }
    },

    methods: {
      traceEvent: function traceEvent(remove) {
        var _this2 = this;

        this.$nextTick(function () {
          var container = options.container.call(_this2);
          _Array$from(container.children).forEach(function (el, index, arr) {
            if (el) {
              el.removeEventListener('mousedown', _this2.onSortStart);
              if (!remove) {
                el.addEventListener('mousedown', _this2.onSortStart);
              }
            }
          });
        });
      },
      eventPathElementHasHandleClass: function eventPathElementHasHandleClass(target, path) {
        var _this3 = this;

        if (!path || !path.length) {
          return false;
        }

        var _loop = function _loop(i) {
          if (path[i].classList && _this3.handleClassList.some(function (cls) {
            return path[i].classList.contains(cls);
          })) {
            return {
              v: true
            };
          }
          if (path[i].tagName === 'LI' && path[i].classList.contains('td-draglist-item')) {
            return 'break';
          }
        };

        _loop2: for (var i = 0; i < path.length; i++) {
          var _ret = _loop(i);

          switch (_ret) {
            case 'break':
              break _loop2;

            default:
              if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
          }
        }

        return false;
      },
      onSortStart: function onSortStart(e) {
        if (this.sortByHandler && !this.eventPathElementHasHandleClass(e.target, e.path)) {
          return;
        }
        if (!this.sortable || e.which !== 1) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();

        var _options = options,
            vertical = _options.vertical,
            supportScroll = _options.supportScroll;


        this.sorting = true;
        this.setupMoveTarget(e);

        var container = options.container.call(this);
        if (supportScroll) {
          this.isScrollable = container.scrollHeight > container.offsetHeight;
          this.scrollHeight = container.scrollHeight;
        }

        this.sortStartC = this.mouseStartC = this.sortPrevC = vertical ? e.clientY : e.clientX;

        container.addEventListener('mouseleave', this.onSortEnd);
        container.addEventListener('mouseup', this.onSortEnd);
        container.addEventListener('mousemove', this.onSortingThrottled);

        this.$emit('on-sort-start', this.ui.insertNodes, e);
      },
      setupMoveTarget: function setupMoveTarget(_ref) {
        var currentTarget = _ref.currentTarget;

        var list = options.getList.call(this);

        this.moveTarget = currentTarget;
        this.moveTargetKey = list[currentTarget.dataset.index].key;
        if (options.multiple) {
          this.moveIndexs = options.getMoveIndexs.call(this);
        } else {
          this.moveIndexs = [Number(currentTarget.dataset.index)];
        }
        this.moveKeys = this.moveIndexs.map(function (index) {
          return list.find(function (item, _index) {
            return index === _index;
          }).key;
        });
      },
      onSorting: function onSorting(e) {
        var _this4 = this;

        var sorting = this.sorting,
            distance = this.distance,
            mouseStartC = this.mouseStartC,
            sortPrevC = this.sortPrevC,
            moveRects = this.moveRects;

        if (sorting) {
          var clientC = options.vertical ? e.clientY : e.clientX;
          if (!this.moving && Math.abs(clientC - mouseStartC) < distance) {
            this.sortStartC = this.sortPrevC = clientC;
            return;
          }
          if (clientC - sortPrevC > 0) {
            this.direction = 'down';
          } else if (clientC - sortPrevC < 0) {
            this.direction = 'up';
          }
          this.sortPrevC = clientC;
          this.moveItem = options.getList.call(this)[this.moveTarget.dataset.index];
          if (!this.startDragHookCalled && options.onDragStart) {
            options.onDragStart.call(this, e, this.moveItem);
            this.startDragHookCalled = true;
          }
          if (!this.areaDistance) {
            var rect = this.moveTarget.getBoundingClientRect();
            this.areaDistance = options.vertical ? rect.height : rect.width;
          }

          this.lastMouseEvent = e;
          if (!moveRects) {
            this.setupRect().then(function () {
              if (_this4.sorting) {
                _this4.moving = true;
                var moveIndexs = options.getMoveIndexs ? options.getMoveIndexs.call(_this4) : _this4.moveIndexs;
                _this4.ui.doCloneNodes(_this4.moveTarget, moveIndexs);
                _this4.ui.updateTranslateY({
                  e: e,
                  moveRects: _this4.moveRects,
                  ulRect: _this4.ulRect,
                  sortStartC: _this4.sortStartC,
                  areaDistance: _this4.areaDistance
                });
                if (options.supportScroll && _this4.isScrollable) {
                  _this4.doScroll(e);
                }
                _this4.handleSort(e, true);
                _this4.ui.doInsertNodes();
              }
            });
          } else {
            this.ui.updateTranslateY({
              e: e,
              moveRects: this.moveRects,
              ulRect: this.ulRect,
              sortStartC: this.sortStartC,
              areaDistance: this.areaDistance
            });
            if (options.supportScroll && this.isScrollable) {
              this.doScroll(e);
            }
            this.handleSort(e, false);
          }

          this.$emit('on-sorting', this.ui.insertNodes, e);
        }
      },
      setupRect: function setupRect() {
        var _this5 = this;

        // 由于可能存在隔项选择，会进行合并，触发dom更新
        // 这里需要等待dom更新
        this.moveRects = [this.moveTarget.getBoundingClientRect()];
        return new _Promise(function (resolve) {
          _this5.$nextTick(function () {
            var container = options.container.call(_this5);
            _this5.ulRect = container.getBoundingClientRect();
            _this5.rects = [];
            options.getList.call(_this5).forEach(function (item, index) {
              var rect = _this5.ui.buildRect(index);
              var _rect = {
                width: rect.width,
                height: rect.height,
                margin: _this5.ui.getMargin(index)
              };
              if (_this5.vertical) {
                _rect.top = rect.top + container.scrollTop;
              } else {
                _rect.left = rect.left + container.scrollLeft;
              }
              _this5.rects.push(_rect);
            });
            resolve();
          });
        });
      },
      updateRect: function updateRect() {
        var _this6 = this;

        if (!this.moving) {
          return;
        }
        var rects = this.rects;

        var _rects = [];
        options.getList.call(this).forEach(function (item, index) {
          var rect = rects[index] || _this6.ui.buildRect(index);
          var _rect = {
            width: rect.width,
            height: rect.height,
            margin: rect.margin === undefined ? _this6.ui.getMargin(index) : rect.margin
          };
          if (_this6.vertical) {
            _rect.top = index === 0 ? rect.top : _rects[index - 1].top + _rects[index - 1].height + _rects[index - 1].margin;
          } else {
            _rect.left = index === 0 ? rect.left : _rects[index - 1].left + _rects[index - 1].width + _rects[index - 1].margin;
          }
          _rects.push(_rect);
        });
        this.rects = _rects;
      },
      handleSort: function handleSort(e, directionIgnore) {
        if (!this.moving || this.rectUpdated === false) {
          return;
        }
        var moveRects = this.moveRects,
            rects = this.rects,
            areaDistance = this.areaDistance,
            sortStartC = this.sortStartC,
            sortPrevC = this.sortPrevC;

        var list = options.getList.call(this);
        var clientC = e ? options.vertical ? e.clientY : e.clientX : sortPrevC;
        var container = options.container.call(this);
        var moveIndexs = void 0;
        if (options.getMoveIndexs) {
          moveIndexs = options.getMoveIndexs.call(this);
        } else {
          moveIndexs = this.moveIndexs;
        }

        // check moveIndexs
        for (var i = 1; i < moveIndexs.length; i++) {
          if (moveIndexs[i] - moveIndexs[i - 1] !== 1) {
            warn('List', 'non-continuous moveIndexs: ' + moveIndexs);
            return this.onSortEnd();
          }
        }

        var moveDistance = void 0;
        if (options.vertical) {
          moveDistance = clientC - sortStartC + moveRects[0].top - rects[moveIndexs[0]].top + container.scrollTop;
        } else {
          moveDistance = clientC - sortStartC + moveRects[0].left - rects[moveIndexs[0]].left + container.scrollLeft;
        }
        var swaped = void 0;
        var moveIndex = void 0;
        if (Math.abs(moveDistance) > areaDistance / 2) {
          // 超过移动区域的一半，更换位置
          if (moveDistance > 0 && (directionIgnore || this.direction === 'down')) {
            // 向下或向右移动
            moveIndex = Math.max.apply(Math, _toConsumableArray(moveIndexs)) + 1;
            if (moveIndex > list.length - 1) {
              return;
            }
            if (this.moved !== '+' + moveIndex) {
              this.moved = '+' + moveIndex;
              var temp = list[moveIndex];
              var rectTemp = _extends({}, rects[moveIndex]);
              for (var _i = moveIndexs.length - 1; _i >= 0; _i--) {
                list[moveIndexs[_i] + 1] = list[moveIndexs[_i]];
                rects[moveIndexs[_i] + 1].width = rects[moveIndexs[_i]].width;
                rects[moveIndexs[_i] + 1].height = rects[moveIndexs[_i]].height;
              }
              list[moveIndexs[0]] = temp;
              rects[moveIndexs[0]].width = rectTemp.width;
              rects[moveIndexs[0]].height = rectTemp.height;
              swaped = true;
            }
          } else if (moveDistance < 0 && (directionIgnore || this.direction === 'up')) {
            // 向上或向左移动
            moveIndex = Math.min.apply(Math, _toConsumableArray(moveIndexs)) - 1;
            if (moveIndex < 0) {
              return;
            }
            if (this.moved !== '-' + moveIndex) {
              this.moved = '-' + moveIndex;
              var _temp = list[moveIndex];
              var _rectTemp = _extends({}, rects[moveIndex]);
              for (var _i2 = 0; _i2 < moveIndexs.length; _i2++) {
                list[moveIndexs[_i2] - 1] = list[moveIndexs[_i2]];
                rects[moveIndexs[_i2] - 1].width = rects[moveIndexs[_i2]].width;
                rects[moveIndexs[_i2] - 1].height = rects[moveIndexs[_i2]].height;
              }
              list[moveIndexs[moveIndexs.length - 1]] = _temp;
              rects[moveIndexs[moveIndexs.length - 1]].width = _rectTemp.width;
              rects[moveIndexs[moveIndexs.length - 1]].height = _rectTemp.height;
              swaped = true;
            }
          }
        }
        if (swaped) {
          if (options.onUpdateList) {
            options.onUpdateList.call(this);
          }
          if (!options.multiple) {
            this.moveIndexs = [moveIndex];
          }
          this.updateRect();
          this.handleSort(undefined, directionIgnore);
        }
      },
      doScroll: function doScroll(e) {
        var _this7 = this;

        if (!this.moving) {
          return;
        }
        var _options2 = options,
            vertical = _options2.vertical;
        var moveRects = this.moveRects,
            sortStartC = this.sortStartC,
            ulRect = this.ulRect,
            offset = this.offset,
            scrollSpeed = this.scrollSpeed,
            areaDistance = this.areaDistance;

        if (!moveRects) {
          return this.onSortEnd();
        }

        var container = options.container.call(this);
        var translateC = (vertical ? e.clientY : e.clientX) - sortStartC + moveRects[0].top - ulRect.top;
        var top = void 0;

        if (container.scrollTop + container.offsetHeight < this.scrollHeight && this.direction === 'down') {
          if (translateC + areaDistance + offset > container.offsetHeight) {
            // scroll down
            top = scrollSpeed;
          }
        } else if (container.scrollTop > 0 && this.direction === 'up') {
          if (translateC < offset) {
            // scroll up
            top = scrollSpeed * -1;
          }
        }
        if (top) {
          if (!this.frame) {
            this.frame = true;
            window.requestAnimationFrame(function () {
              _this7.frame = false;
              _this7.updateScrollTop(top);
              if (_this7.lastMouseEvent) {
                _this7.ui.updateTranslateY({
                  e: _this7.lastMouseEvent,
                  moveRects: _this7.moveRects,
                  ulRect: _this7.ulRect,
                  sortStartC: _this7.sortStartC,
                  areaDistance: _this7.areaDistance
                });
                _this7.doScroll(_this7.lastMouseEvent);
              }
            });
          }
        }
      },
      updateScrollTop: function updateScrollTop(top) {
        if (!this.moving) {
          return;
        }
        var container = options.container.call(this);
        this.scrollTop = container.scrollTop = Math.min(this.scrollHeight - container.offsetHeight, (this.scrollTop || container.scrollTop) + top);
        this.handleSort(this.lastMouseEvent);
      },
      onSortEnd: function onSortEnd() {
        if (this.sorting) {
          this.sorting = this.moving = false;
          this.startDragHookCalled = this.moveItem = this.moveTargetIndexs = this.moved = this.lastMouseEvent = this.areaDistance = null;
          if (options.vertical && this.supportScroll) {
            this.scrollTop = this.scrollHeight = this.isScrollable = null;
          }

          this.$emit('on-sort-end', this.ui.insertNodes);

          this.ui.doRemoveNodes();
          this.destoryMoveTarget();
          this.destoryRect();

          var container = options.container.call(this);
          container.removeEventListener('mouseleave', this.onSortEnd);
          container.removeEventListener('mouseup', this.onSortEnd);
          container.removeEventListener('mousemove', this.onSortingThrottled);

          if (options.onSortEnd) {
            options.onSortEnd.call(this);
          }
        }
      },
      destoryMoveTarget: function destoryMoveTarget() {
        this.moveKeys = this.moveTargetKey = this.moveIndexs = this.moveTarget = null;
      },
      destoryRect: function destoryRect() {
        this.moveRects = this.ulRect = this.rects = null;
      },
      handleScroll: function handleScroll() {
        if (this.sorting && this.lastMouseEvent) {
          this.ui.updateTranslateY({
            e: this.lastMouseEvent,
            moveRects: this.moveRects,
            ulRect: this.ulRect,
            sortStartC: this.sortStartC,
            areaDistance: this.areaDistance
          });
        }
      }
    },
    beforeDestory: function beforeDestory() {
      if (this.sortable) {
        options.container.call(this).removeEventListener('scroll', this.handleScroll);
        this.traceEvent(true);
      }
    }
  };
}

export default createDragMixin;
